import type { RefData } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { errors } from '../errors'
import { unwrapPaginated } from '../normalize'

// v2 renamed this table; consumers still address it by its v1 key.
const REF_DATA_KEY_ALIASES: Record<string, string> = {
  RefMetricEventStatus: 'RefMetricStatus',
}

// v2 defaults to size=10, which silently truncates the larger tables (RefCattleSubClass has 29
// rows). 200 stays under the endpoint's MAX_PAGE_SIZE cap of 1000.
const REF_DATA_PAGE_SIZE = 200

// Not narrowed beyond string: v2 sorts only by es_AR or en_US and drops any other field
// silently, so the callable keys are exactly the label tables, all of which have es_AR.
export default async function getRefData(
  key: string,
  { programIds, signal }: { programIds?: number[]; signal?: AbortSignal } = {},
): Promise<RefData[]> {
  const response = await apiClient.get(endpoints.v2.refData(REF_DATA_KEY_ALIASES[key] ?? key), {
    params: { size: REF_DATA_PAGE_SIZE, sort: 'es_AR:asc', ...(programIds ? { programIds } : {}) },
    signal,
  })
  const { items, pagination } = unwrapPaginated<RefData>(response)
  if (pagination.totalPages > 1) {
    throw new errors.UnexpectedEntityError({
      message: `Reference data '${key}' exceeded one page (${pagination.total} rows)`,
    })
  }
  return items
}
